import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { SelfCollectionModalCard } from "./self-collection-modal-card.component";

/**
 * Order cancelled confirmation modal (KIT-06). Reached when the user
 * confirms cancellation on the previous cancellation screen. Renders
 * the BE-driven Masonry tree at `selfCollection$orderCancelled$root`.
 *
 * BE follow-up: masonry root delivery tracked separately with Egor.
 */
export const SelfCollectionOrderCancelledPage = () => {
  usePageViewAnalytics({ screen_name: "Self Collection Order Cancelled" });
  const { formatMessage } = useIntl();

  useDocumentTitle(
    formatMessage({ id: "STR_SELF_COLLECTION_ORDER_CANCELLED" })
  );

  return (
    <SelfCollectionModalCard>
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_ID_SELF_COLLECTION_ORDER_CANCELLED}
      />
    </SelfCollectionModalCard>
  );
};
